module.exports = __webpack_public_path__ + "static/media/drm_video_system_p.5d5cc0e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/drm_video_system_p.jpg
// module id = 361
// module chunks = 0